import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { PoliciesService } from 'src/app/shared/services/policyservices/policies.service';
import { FormsModule, NgForm } from '@angular/forms';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, CollapseModule,],
})

/**
 * array for data of policies
 *
 */
export class MainComponentCompanyPolicy implements OnInit {
  public policies: any = [];
  public showSpinner = true;
  public isCollapsed = -1;

  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  user: any;
  constructor(private policyservice: PoliciesService, private router: Router, public dashboardService: DashboardService,
    private sharedmode: SharedModeService,) {
    this.getPolicyData();
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  getPolicyData() {
    this.policyservice.getPolicy().then((value) => {
      if (value.success == true) {
        this.policies = value.data;
        this.showSpinner = false;
      }
    });
  }

  onSubmit(f: NgForm) {
    this.showSpinner = true;
    this.policies = [];
    this.policyservice
      .getPolicyFilter(f.value.date, f.value.month, f.value.year)
      .then((value) => {
        //  alert('value');
        this.showSpinner = false;
        this.policies = value.data;
      });
  }

  onReset() {
    // alert('here');
    this.showSpinner = true;
    this.getPolicyData();
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
}
